import React, { useState, useEffect } from "react";
import { LinearProgress, Typography, Box } from "investira.react.components";

const LoadingMessages = (props) => {
  const { loading, messages } = props;
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    if (!loading) {
      return;
    }

    const xInterval = setInterval(() => {
      setCurrentMessageIndex(
        (xPrevIndex) => (xPrevIndex + 1) % messages.length
      );
    }, 10000);

    return () => clearInterval(xInterval);
  }, [loading, messages.length]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <LinearProgress style={{ width: "100%" }} />
      <Typography variant="body1" style={{ marginTop: 16 }}>
        {messages[currentMessageIndex]}
      </Typography>
    </Box>
  );
};

export default LoadingMessages;
